/**
 * Controller for the vd-suggestion-list component that renders a list of suggestions for the Autocomplete or
 * Dropdown components.
 *
 * @class SuggestionListController
 */
export default class SuggestionListController {
  constructor($attrs, $element, $scope) {
    'ngInject'
    this._$attrs = $attrs
    this._$element = $element
    this._$scope = $scope
  }

  $postLink() {
    this._$attrs.$addClass('vd-suggestion-list-container')

    this._$scope.$applyAsync(() => {
      this._$scope.$watch('$ctrl.data.activeIndex', () => {
        this._ensureActiveSuggestionVisible()
      })

      this._$scope.$watch('$ctrl.data.suggestions.length', () =>
        this._ensureActiveSuggestionVisible()
      )
    })
  }

  /**
   * Determine whether the suggestion at the specified index (and group index) is active according to the current
   * activeIndex.
   *
   * @method isActive
   * @param  {Number} [groupStartIndex=0] Start index of suggestions in the current group
   * @param  {Number} index Index of the suggestion within its group
   *
   * @return {Boolean} True if the suggestion at the given index is currently active, false otherwise
   */
  isActive(groupStartIndex = 0, index) {
    return (
      !this.data.activeFooter &&
      groupStartIndex + index === this.data.activeIndex
    )
  }

  /**
   * Whether or not to show the clear selected item footer.
   *
   * @method showClear
   * @return {Boolean}
   */
  showClear() {
    return Boolean(this.allowClear && this.source.canClear(this.data))
  }

  /**
   * Whether or not to show the footer.
   */
  showFooter() {
    return Boolean(this.source.canCreate(this.data) || this.showClear())
  }

  /**
   * Determine whether the current active suggestion is visible and if not scroll to it.
   *
   * @private
   * @method _ensureActiveSuggestionVisible
   */
  _ensureActiveSuggestionVisible() {
    if (!this.data.suggestions.length) {
      return
    }

    const scrollContainerEl = this._$element[0].querySelector('.vd-scrollable')
    const suggestionEl = scrollContainerEl.querySelector(
      `.vd-suggestion[data-active-index="${this.data.activeIndex}"]`
    )

    if (!suggestionEl) {
      return
    }

    const popoverHeight = scrollContainerEl.getBoundingClientRect().height
    const {
      height: suggestionHeight,
      top: suggestionTop,
    } = suggestionEl.getBoundingClientRect()

    if (suggestionTop + suggestionHeight > popoverHeight) {
      scrollContainerEl.scrollTop +=
        suggestionTop + suggestionHeight - popoverHeight
    } else if (suggestionTop < 0) {
      if (this.data.activeIndex === 0) {
        scrollContainerEl.scrollTop = 0
      } else {
        scrollContainerEl.scrollTop += suggestionTop
      }
    }
  }
}
